<template>
<div class="page page-settings">
	<div class="container" v-if="isRouteChecked">
		<div class="page-header">
			<h1 class="page-title">Settings</h1>
		</div>

		<!-- Integrations -->
		<div class="page-content">
			<div class="box box--lg">
				<div class="box__title">Integrations</div>
				<div class="integrations">
					<!-- Autoresponder -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">email</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/autoresponder" class="integration__title">Autoresponder</router-link>
										<div class="integration__info">Add customers to list, tags, and sequence in your autoresponder.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/autoresponder">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Customer File -->
					<div class="integration" hidden>
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">account_circle</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/customer-file" class="integration__title">Customer File</router-link>
										<div class="integration__info">Add customers to Facebook Custom Audience with LTV and to Google Contacts.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/customer-file">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Notification -->
					<div class="integration">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<!-- <i class="integration__icon material-icons">notifications</i> -->
										<i class="integration__icon fi fi-rr-bell"></i>
									</div>
									<div class="col-10">
										<router-link to="/settings/notification" class="integration__title">Notification</router-link>
										<div class="integration__info">Get Notification when there is an order.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/notification">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Payment Gateway -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<!-- <i class="integration__icon material-icons">payment</i> -->
										<i class="integration__icon fi fi-rr-credit-card"></i>
									</div>
									<div class="col-10">
										<router-link to="/settings/payment" class="integration__title">Payment Processor</router-link>
										<div class="integration__info">Accept Payments from your customers.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/payment">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- SMS Gateway -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">sms</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/sms" class="integration__title">SMS Gateway</router-link>
										<div class="integration__info">Send messages to your customers via SMS.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/sms">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Tracking -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<!-- <i class="integration__icon material-icons">bar_chart</i> -->
										<i class="integration__icon fi fi-rr-stats"></i>
									</div>
									<div class="col-10">
										<router-link to="/settings/tracking" class="integration__title">Tracking</router-link>
										<div class="integration__info">Integrate to tracking tools.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/tracking">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- WhatsApp Gateway -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">chat</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/whatsapp" class="integration__title">WhatsApp Gateway</router-link>
										<div class="integration__info">Send messages to your customers via WhatsApp.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/whatsapp">View Settings</router-link>
							</div>
						</div>
					</div>
					<!-- Connection -->
					<div v-if="isDropshipper" class="integration">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon fi fi-rr-link"></i>
									</div>
									<div class="col-10">
										<router-link to="/settings/connections" class="integration__title">Connections</router-link>
										<div class="integration__info">Connect your ostock account to another apps.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/connections">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Marktplace -->
					<div v-if="isDropshipper" class="integration">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon fi fi-rr-shop"></i>
									</div>
									<div class="col-10">
										<router-link to="/settings/marketplace" class="integration__title">Marketplace</router-link>
										<div class="integration__info">Connect your marketplace account.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/marketplace">View Settings</router-link>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Online Store -->
		<div class="page-content" :class="{ 'hidden' : !isSupplier }">
			<div class="box box--lg">
				<div class="box__title">Store</div>
				<div class="integrations">
					<!-- Store Information -->
					<div class="integration">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">store_mall_directory</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/store" class="integration__title">Store Information</router-link>
										<div class="integration__info">Update your store information</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/store">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Multi Warehouse -->
					<div v-if="isHasFeature('product_multiwarehouse')" class="integration">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">warehouse</i>
									</div>
									<div class="col-10">
										<router-link
											to="/settings/warehouse"
											class="integration__title">
											{{ $t('Warehouse') }}
										</router-link>
										<div
											class="integration__info">
											{{ $t('Set up multi warehouses') }}.
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link
									class="btn btn-primary"
									to="/settings/warehouse">
									{{ $t('View Settings') }}
								</router-link>
							</div>
						</div>
					</div>

					<!-- General Settings -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">settings</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/general" class="integration__title">General Settings</router-link>
										<div class="integration__info"></div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/general">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Custom Domain -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">cloud</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/customdomain" class="integration__title">Custom Domain</router-link>
										<div class="integration__info">Use your own existing domain that pointing to your checkout pages.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/customdomain">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Tag Settings -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">label</i>
										<!-- <icon name="tag" scale="0.8"></icon> -->
									</div>
									<div class="col-10">
										<router-link to="/settings/tag" class="integration__title">Tag Settings</router-link>
										<div class="integration__info"></div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/tag">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Collections -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">category</i>
										<!-- <icon name="tag" scale="0.8"></icon> -->
									</div>
									<div class="col-10">
										<router-link to="/settings/collections" class="integration__title">Collections</router-link>
										<div class="integration__info"></div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/collections">View Settings</router-link>
							</div>
						</div>
					</div>

					<!-- Shipping -->
					<div class="integration hidden">
						<div class="row">
							<div class="col-sm-9">
								<div class="row">
									<div class="col-2 col-icon">
										<i class="integration__icon material-icons">local_shipping</i>
									</div>
									<div class="col-10">
										<router-link to="/settings/shipping" class="integration__title">{{ $t('Shipping') }}</router-link>
										<div class="integration__info">{{ $t('Set automation for shipping') }}.</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3 text-right">
								<router-link class="btn btn-primary" to="/settings/shipping">{{ $t('View Settings') }}</router-link>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'settings',
	data() {
		return {
			isRouteChecked: false,
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
		}),
		checkCapabilities() {
			const isOwner = this.user.role === 'owner' || this.user.role === 'dropshipper';
			if (!isOwner) {
				this.$router.push('/');
			}
			this.isRouteChecked = true;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isFetching: 'settings/isFetching',
			isHasFeature: 'isHasFeature',
			accounts: 'settings/accounts',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
		}),
	},
	watch: {
		user(user) {
			if (user) {
				this.checkCapabilities();
			}
		},
	},
	created() {
		if (this.user) {
			this.checkCapabilities();
		}
		if (!this.isFetching) {
			this.fetchAccounts();
		}
	},
};
</script>
